module.exports = __webpack_public_path__ + "static/media/burger.3de22e27.png";